import sideImg from "../assets/bookclub.jpeg";

export const upcomingEventsData = [
  {
    id: "evt_design_thinking",
    category: "Workshop",
    title: "Design Thinking Fundamentals",
    shortDescription:
      "Learn human-centered design methodology to create meaningful solutions for real-world challenges.",
    description:
      "Join us for an immersive workshop exploring the intersection of design thinking and community impact. Through collaborative exercises, case studies, and practical frameworks, you'll learn how to identify needs, prototype solutions, and iterate using user feedback.\n\nThis session is perfect for community builders, entrepreneurs, and changemakers who want to develop human-centered solutions to real-world challenges.",
    coverImage:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=70",
    location: "NeherBaari",
    dateTime: "2026-02-15T14:00:00+05:30",
    endDateTime: "2026-02-15T17:00:00+05:30",
    capacity: 15,
    seatsRemaining: 8,
    priceLabel: "Free for members",
    facilitator: {
      name: "Arjun Sharma",
      role: "Design Strategy Lead at Social Impact Lab",
      experience: "10+ years experience in human-centered design for social good",
      avatar:
        "https://images.unsplash.com/photo-1520975693416-35a6d4b2be15?auto=format&fit=crop&w=220&q=70"
    },
    whatYouWillExperience: [
      "Hands-on design thinking methodology",
      "Collaborative prototyping session",
      "Real community challenge case studies",
      "Actionable framework for future projects"
    ]
  },

  {
    id: "evt_sustainable_models",
    category: "Talk",
    title: "Sustainable Business Models",
    shortDescription:
      "A practical session on building sustainable business models and impact-driven growth.",
    description:
      "A talk focused on sustainable business model design, pricing, and long-term viability. We’ll cover frameworks and real examples, and end with a Q&A discussion.",
    coverImage:
      "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1600&q=70",
    location: "NeherBaari",
    dateTime: "2026-02-18T18:00:00+05:30",
    endDateTime: "2026-02-18T19:30:00+05:30",
    capacity: 30,
    seatsRemaining: 12,
    priceLabel: "Free for members",
    facilitator: {
      name: "Meera Kapoor",
      role: "Impact Venture Advisor",
      experience: "8+ years helping founders build sustainable businesses",
      avatar:
        "https://images.unsplash.com/photo-1544723795-3fb6469f5b39?auto=format&fit=crop&w=220&q=70"
    },
    whatYouWillExperience: [
      "Business model design frameworks",
      "Real examples and case studies",
      "Q&A and founder discussion"
    ]
  },

  {
    id: "evt_community_mixer",
    category: "Networking",
    title: "Community Mixer",
    shortDescription:
      "Meet other builders and creatives — a relaxed evening of community networking.",
    description:
      "A casual community networking session. Meet new people, share what you're working on, and discover collaboration opportunities.",
    coverImage: sideImg,
    location: "NeherBaari",
    dateTime: "2026-02-22T19:00:00+05:30",
    endDateTime: "2026-02-22T21:00:00+05:30",
    capacity: 40,
    seatsRemaining: 20,
    priceLabel: "Free entry",
    facilitator: {
      name: "NeherBaari Team",
      role: "Community",
      experience: "Hosted 100+ events & experiences",
      avatar:
        "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=220&q=70"
    },
    whatYouWillExperience: [
      "Light networking & introductions",
      "Find collaborators",
      "Community updates"
    ]
  }
];

export function getEventById(id) {
  return upcomingEventsData.find((e) => e.id === id) || null;
}
